import { useQuery } from '@tanstack/react-query'
import { useOrpc } from '@/hooks/useClient'
import type { OrpcClient } from '@/orpc/client'

export type PatientCareTask = Awaited<ReturnType<OrpcClient['patientCareTasks']>>['tasks'][number]
export type PatientCareTaskType = PatientCareTask['type']

/** Every Care Queue task for the patient, open and completed, newest first (PD-1870). */
export function usePatientCareTasks(patientId: string | undefined) {
  const orpc = useOrpc()
  return useQuery(
    orpc.patientCareTasks.queryOptions({
      input: { patientId: patientId ?? '' },
      enabled: !!patientId,
    }),
  )
}
